import { logEngagementEvent } from "./events";

const PATIENT_APP_CLICK_EVENT_TYPE = "PATIENT_APP_CLICK";
const FEATURE_VIEW_EVENT_TYPE = "FEATURE_VIEW";

export async function recordFeatureViewEngagement(
    eventTarget = "",
    eventDetails?: Record<string, any>,
) {
    return logEngagementEvent({
        type: FEATURE_VIEW_EVENT_TYPE,
        target: eventTarget,
        details: eventDetails,
    });
}

export async function recordPatientAppClickEngagement(
    eventTarget = "",
    eventDetails?: Record<string, any>,
) {
    return logEngagementEvent({
        type: PATIENT_APP_CLICK_EVENT_TYPE,
        target: eventTarget,
        details: eventDetails,
    });
}
